import { render, staticRenderFns } from "./StockADView.vue?vue&type=template&id=fd7ef756&scoped=true"
import script from "./StockADView.vue?vue&type=script&lang=js"
export * from "./StockADView.vue?vue&type=script&lang=js"
import style0 from "./StockADView.vue?vue&type=style&index=0&id=fd7ef756&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd7ef756",
  null
  
)

export default component.exports